'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CompletedOnlyCheckbox = undefined;

var _Style = require('./Style');

var _Style2 = _interopRequireDefault(_Style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CompletedOnlyCheckbox = function CompletedOnlyCheckbox(refs) {
    var i18n = refs.i18nManager.get();

    return Ext.create('Ext.form.field.Checkbox', {
        boxLabel: i18n.include_only_completed_events_only,
        style: 'margin-bottom:' + _Style2.default.checkboxBottomMargin + 'px'
    });
};

exports.CompletedOnlyCheckbox = CompletedOnlyCheckbox;
exports.default = CompletedOnlyCheckbox;
//# sourceMappingURL=CompletedOnly.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/ui/options/CompletedOnly.js
 ** module id = 352
 ** module chunks = 0
 **/